/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React from 'react';
import { useTable, useSortBy, usePagination } from 'react-table';
import './claimdetails.scss';

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
});
const Table = ({ columns, data, isSuppressPaymentInfo, overlay }) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    footerGroups,
    page,
    prepareRow,
    setPageSize,
    pageCount,
    state: { pageSize },
  } = useTable(
    {
      columns,
      data,
      disableSortRemove: true,
      initialState: {
        pageSize: 7,
        sortBy: [
          {
            id: 'ServiceDate',
            desc: false,
          },
        ],
      },
    },
    useSortBy,
    usePagination,
  );

  const renderCodes = (RPCode) => {
    const RevnueProcedureCode = RPCode.split('/');
    const returnString =
      RevnueProcedureCode[0] != '' && RevnueProcedureCode[1] != '' ? (
        <span className="d-flex claims-service-grid-tooltip">
          <span>{overlay(RevnueProcedureCode[0], 'Revenue Codes')}</span> -
          <span> {overlay(RevnueProcedureCode[1], 'ProcedureCode')}</span>
        </span>
      ) : RevnueProcedureCode[0] === '' && RevnueProcedureCode[1] != '' ? (
        <span className="claims-service-grid-tooltip">
          {overlay(RevnueProcedureCode[1], 'ProcedureCode')}
        </span>
      ) : RevnueProcedureCode[0] != '' && RevnueProcedureCode[1] === '' ? (
        <span className="claims-service-grid-tooltip">
          {overlay(RevnueProcedureCode[0], 'Revenue Codes')}
        </span>
      ) : (
        '---'
      );
    return returnString;
  };

  const getfromandThroughDate = (dateValue) => {
    if (dateValue) {
      const dateInfo = dateValue.split('_');
      return dateInfo[0] != 'null' && dateInfo[1] != 'null' ? (
        <>
          <span>{dateInfo[0]} - </span>
          <br />
          <span>{dateInfo[1]}</span>
        </>
      ) : (
        'XXXXXX'
      );
    } else {
      return 'XXXXXX';
    }
  };

  return (
    <>
      <div className="claim-details-showing">
        {data.length < 10
          ? `Showing 1 - ${data.length} of ${data.length} services`
          : pageCount >= 2
          ? `Showing 1 - 10 of ${data.length} services`
          : `Showing 1 - ${data.length} of ${data.length} services`}
      </div>
      <div className="claims-table-layout">
        <table {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup, index) => (
              <tr key={index} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => {
                  return (
                    <th
                      key={index}
                      {...column.getHeaderProps(
                        column.getSortByToggleProps({ title: undefined }),
                      )}
                      style={{
                        width: column.width,
                      }}
                      className={
                        column.isSorted ? 'coloumnIsSorted' : 'coloumnNotSorted'
                      }
                    >
                      <b>{column.render('Header')}</b>
                      <span
                        className={
                          column.isSorted
                            ? column.isSortedDesc
                              ? 'arrowDown'
                              : 'arrowUp'
                            : 'arrowNormal'
                        }
                      ></span>
                    </th>
                  );
                })}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row, index) => {
              prepareRow(row);
              return (
                <tr key={index} {...row.getRowProps()}>
                  {row.cells.map((cell, index) => {
                    return (
                      <td key={index} {...cell.getCellProps()}>
                        <p
                          className={
                            !isSuppressPaymentInfo
                              ? 'claims-data'
                              : 'claims-data-suppress'
                          }
                        >
                          {cell.column.Header === 'Charges' ||
                          cell.column.Header === 'Discount' ||
                          cell.column.Header === 'Payment Amount' ||
                          cell.column.Header === 'Deductible' ||
                          cell.column.Header === 'Covered' ||
                          cell.column.Header === 'Coinsurance$' ||
                          cell.column.Header === 'Not Paid' ? (
                            cell.value != -1 ? (
                              formatter.format(cell.value)
                            ) : (
                              '---'
                            )
                          ) : cell.column.Header === 'Service Date' ? (
                            getfromandThroughDate(cell.value)
                          ) : cell.column.Header === 'Service Code' ? (
                            renderCodes(cell.value)
                          ) : cell.column.Header === 'Benefit Code' ? (
                            <span className="claims-service-grid-tooltip">
                              {overlay(cell.value, 'BENEFIT CODES')}
                            </span>
                          ) : cell.column.Header === 'Reason' ? (
                            <span className="claims-service-grid-tooltip">
                              {overlay(cell.value, 'DENIED REASON')}
                            </span>
                          ) : (
                            cell.render('Cell')
                          )}
                        </p>
                      </td>
                    );
                  })}
                </tr>
              );
            })}
            {pageCount >= 2 && (
              <button
                id="showmore"
                className="unstyled-button"
                onClick={() => {
                  setPageSize(pageCount * pageSize);
                  console.log('page size: ', pageCount * pageSize);
                  document.getElementById('showmore').style.visibility =
                    'hidden';
                }}
              >
                SHOW MORE...
              </button>
            )}

            {pageCount == 1}
            <tr className="bg-white" colSpan="10"></tr>
          </tbody>
          <tfoot>
            {footerGroups.map((footerGroup, index) => (
              <tr key={index} {...footerGroup.getFooterGroupProps()}>
                {footerGroup.headers.map((column) => (
                  <td {...column.getFooterProps} key={column.id}>
                    {column.render('Footer')}
                  </td>
                ))}
              </tr>
            ))}
          </tfoot>
        </table>
      </div>
    </>
  );
};

export default Table;
